import call from "./call.component";

const callModule = angular
  .module("app.components.call", [])
  .component("call", call);

export default callModule;



// WEBPACK FOOTER //
// ./src/components/call/call.module.js